<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <BoxInformationForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BoxInformationForm from '@/components/organisms/terminal/form/BoxInformationForm.vue'

export default {
  name: 'EditInspIndexPage',

  components: {
    BoxInformationForm,
  },
}
</script>
